<template>
  <router-view />
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { watch, onMounted, nextTick } from 'vue';
import { useRoute } from 'vue-router';
import { SessionStorageKey, LocalStorageKey } from '@/shared/constants/storageKeys';
import { useAnalytics } from '@/analytics/useAnalytics';

const { t, locale } = useI18n();
const route = useRoute();
const { initAnalytics } = useAnalytics();

document.title = t('appTitle');

watch(locale, () => {
  document.title = t('appTitle');
});

const detectVersionFromPath = (path) => {
  console.log('detectVersionFromPath called with path:', path);

  if (path.includes('/auth')) {
    console.log('OAuth callback detected');
    // При возврате с OAuth восстанавливаем версию из localStorage
    const tempVersion = localStorage.getItem(LocalStorageKey.OAUTH_TEMP_VERSION);
    if (tempVersion) {
      console.log('Restoring version from localStorage:', tempVersion);
      sessionStorage.setItem(SessionStorageKey.VERSION, tempVersion);
      localStorage.removeItem(LocalStorageKey.OAUTH_TEMP_VERSION); // Очищаем временное хранилище
    }
    return;
  }

  // Проверяем паттерн /v{число}/
  const versionMatch = path.match(/\/v(\d+)\//);
  if (versionMatch) {
    const version = parseInt(versionMatch[1], 10);
    sessionStorage.setItem(SessionStorageKey.VERSION, version.toString());
    return;
  }

  sessionStorage.setItem(SessionStorageKey.VERSION, '1');
};

watch(() => route.path, (newPath) => {
  detectVersionFromPath(newPath);
}, { immediate: true });

onMounted(() => {
  nextTick(() => {
    detectVersionFromPath(route.path);
  });

  initAnalytics();
});

</script>

<style lang="scss" module>
@use '@/shared/sass/index' as *;

:global(#app) {
  height: 100%;
}

:global(html) {
  height: 100% !important;
}

:global(body) {
  height: 100% !important;
  font-family: old.$global-font;
  color: old.$color-text;

  @media (min-width: 767px) {
    font-size: calc(16px * var(--font-scale));
  }
}

</style>
